import { render, staticRenderFns } from "./FilmItem.vue?vue&type=template&id=25ef580e"
import script from "./FilmItem.vue?vue&type=script&lang=js"
export * from "./FilmItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports